export class Banco {

    private id: number;
    private codigo: string;
    private nome: string;
    private apelido: string;

    public getId(): number {
        return this.id;
    }

    public setId(id: number): void {
        this.id = id;
    }

    public getCodigo(): string {
        return this.codigo;
    }

    public setCodigo(codigo: string): void {
        this.codigo = codigo;
    }

    public getNome(): string {
        return this.nome;
    }

    public setNome(nome: string): void {
        this.nome = nome;
    }

    public getApelido(): string {
        return this.apelido;
    }

    public setApelido(apelido: string): void {
        this.apelido = apelido;
    }

}



// WEBPACK FOOTER //
// ./src/app/resources/classes/banco.ts